<template>
  <div />
</template>

<script>
import * as echarts from "echarts";

export default {
  props: {
    counts: {
      type: Object,
    },
    cursiteInfo: {
      type: Object,
    },
  },
  data() {
    //防抖
    const debounce = (fn) => {
      let timer;
      return function () {
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          fn();
        }, 200);
      };
    };
    return {
      chart: null,
      cancalDebounce: debounce(this.windowResize),
      data1: [],
      data2: [],
      persent: "0%",
    };
  },
  activated() {
    this.$nextTick(() => {
      //解决数据还没初始化就初始化表格的bug
      setTimeout(() => {
        this.initChart();
      }, 200);
    });
    window.addEventListener("resize", this.cancalDebounce);
  },
  mounted() {
    this.$nextTick(() => {
      //解决数据还没初始化就初始化表格的bug
      setTimeout(() => {
        this.initChart();
      }, 200);
    });
    window.addEventListener("resize", this.cancalDebounce);
  },
  methods: {
    windowResize() {
      //销毁图表重新画;
      setTimeout(() => {
        if(this.chart){
        this.chart.dispose();

        }
        this.initChart();
      }, 100);
    },
    initChart() {
      this.chart = echarts.init(this.$el);

      this.setOptions();
    },
    setOptions() {
      let color = ["#FA6400", "#F7B500", "#44D7B6"];
      let echartData = [
        {
          name: "告警",
          value: this.cursiteInfo.alarmElevatorCount>0?this.cursiteInfo.alarmElevatorCount:null,
        },
        {
          name: "预警",
          value: this.cursiteInfo.warningElevatorCount>0?this.cursiteInfo.warningElevatorCount:null,
        },
        {
          name: "正常",
          value: this.cursiteInfo.normalElevatorCount>0?this.cursiteInfo.normalElevatorCount:null,
        },
        {
          name: "离线",
          value: this.cursiteInfo.unOnlineElevatorCount>0?this.cursiteInfo.unOnlineElevatorCount:null,
        },
      ];
      let total =
        this.cursiteInfo.warningElevatorCount +
        this.cursiteInfo.alarmElevatorCount +
        this.cursiteInfo.normalElevatorCount +
        this.cursiteInfo.unOnlineElevatorCount;
      let HealthyPercent =
        (this.cursiteInfo.normalElevatorCount / total* 100).toFixed(0) ;
      let formatNumber = function (num) {
        let reg = /(?=(\B)(\d{3})+$)/g;
        return num.toString().replace(reg, ",");
      };

      if (!this.chart) {
        return;
      }
      this.chart.setOption({
        backgroundColor: "transparent",
        color: color,
        title: [
          {
            text: HealthyPercent != -100 ? HealthyPercent + "%" : 0 + "%",
            x: "center",
            top: "42%",
            textStyle: {
              fontSize: 28,
              color: "#44D7B6",
              foontWeight: "500",
            },
          },
          {
            text: "健康指数",
            x: "center",
            top: "58%",
            textStyle: {
              color: "#44D7B6",
              fontSize: 12,
              fontWeight: "100",
            },
          },
        ],
        polar: {
          radius: ["44%", "50%"],
          center: ["50%", "50%"],
        },
        angleAxis: {
          max: 100,
          show: false,
        },
        radiusAxis: {
          type: "category",
          show: true,
          axisLabel: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            color: color,
            type: "pie",
            radius: ["55%", "67%"],
            center: ["50%", "50%"],
            data: echartData,
            hoverAnimation: false,
            itemStyle: {
              normal: {
                borderColor: "transparent",
                borderWidth: 2,
              },
            },
            
            labelLine: {
              normal: {
                length: 20,
                length2: 0,
              },
            },
            label: {
              normal: {
                formatter: (params) => {
                  return (
                    "{name|" +
                    params.name +
                    "}\n{value|" +
                    formatNumber(params.value) +
                    "}"
                  );
                },
                padding: [0, 0, 0, 0],
                rich: {
                  icon: {
                    fontSize: 16,
                    align: "left",
                    padding: [4, 0, 0, 0],
                  },
                  name: {
                    fontSize: 12,
                    align: "left",
                    padding: [4, 0, 0, 0],

                    color: "#7F8488",
                  },
                  value: {
                    fontSize: 18,
                    fontWeight: "bold",
                    // color: "#00f0ff",
                    color: "inherit", 
                    align: "left",
                  },
                },
              },
            },
          },
        ],
      });
    },
  },
  watch: {
    cursiteInfo: {
      deep: true,
      handler: function () {
        this.setOptions();
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pieChart.vue